import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { withRouter, NavLink } from "react-router-dom";
import { Strip } from "./Common";

const renderBreadcrumb = breadcrumb => {
  let previous = "";
  return breadcrumb.map((item, index) => {
    const isLast = index === breadcrumb.length - 1;
    const ItemToRender = isLast ? (
      <span>{item}</span>
    ) : (
      <NavLink to={`/${previous}${item}`}>{item}</NavLink>
    );
    previous += `${item}/`;
    return (
      <div key={Math.random()}>
        {ItemToRender}
        {!isLast && <span className="arrow" />}
      </div>
    );
  });
};

export const BreadcrumbComp = ({ className, sectionTitle, location }) => {
  const { pathname } = location;
  const breadcrumb = pathname.split("/").slice(1);
  return (
    <Strip className={className} flexDirection="column">
      <h2 className="page-title">{sectionTitle}</h2>
      <div className="breadcrumb">{renderBreadcrumb(breadcrumb)}</div>
    </Strip>
  );
};

BreadcrumbComp.propTypes = {
  className: PropTypes.string,
  sectionTitle: PropTypes.string,
  location: PropTypes.shape({}).isRequired
};

BreadcrumbComp.defaultProps = {
  className: "",
  sectionTitle: ""
};

export const Breadcrumb = styled(withRouter(BreadcrumbComp))`
  padding: 10px 20px;
  font-family: ${/* istanbul ignore next */ ({ theme }) =>
    theme.fontFamily.BOLD};
  .page-title {
    font-size: ${/* istanbul ignore next */ ({ theme }) =>
      theme.fontSize.LARGE};
    margin-bottom: 10px;
    padding-bottom: 0;
    color: ${/* istanbul ignore next */ ({ theme }) => theme.palette.SECONDARY};
  }
  .breadcrumb {
    display: flex;
    text-transform: capitalize;
    a {
      font-size: ${/* istanbul ignore next */ ({ theme }) =>
        theme.fontSize.SMALL};
      color: ${/* istanbul ignore next */ ({ theme }) =>
        theme.palette.SECONDARY};
      text-decoration: none;
    }
    span {
      font-size: ${/* istanbul ignore next */ ({ theme }) =>
        theme.fontSize.SMALL};
      color: ${/* istanbul ignore next */ ({ theme }) =>
        theme.palette.DARK_GREY};
    }
    .arrow {
      padding: 0 12px;
      position: relative;
      &:before,
      &:after {
        content: "";
        position: absolute;
        border-color: transparent;
        border-width: 4px;
        display: inline-block;
        border-style: solid;
        top: 3px;
        left: 11px;
      }
      &:before {
        border-left-color: ${/* istanbul ignore next */ ({ theme }) =>
          theme.palette.DARK_GREY};
      }
      &:after {
        border-left-color: ${/* istanbul ignore next */ ({ theme }) =>
          theme.palette.LIGHT};
        left: 9px;
      }
    }
  }
`;
